import {
  TASK_ACTIVITY_TYPES,
  TaskState,
  createIssueUpdatesChangeExtension,
} from '@spotify/plugin-confidence-issues-react';

import { TaskActivityContext } from '../TaskActivityContext';
import { isTaskActivityType } from './issueActivityUtils';

const getActionTitle = (newState: unknown): string => {
  if (newState === TaskState.InProgress) {
    return 'Task started';
  }

  if (newState === TaskState.Open) {
    return 'Task stopped';
  }

  if (newState === TaskState.Completed) {
    return 'Task completed';
  }

  if (newState === TaskState.Failed) {
    return 'Task failed';
  }

  if (newState === TaskState.WaitingForInput) {
    return 'Task needs input';
  }

  return 'Updated task state';
};

export const TASK_STATE_CHANGE_EXTENSION = createIssueUpdatesChangeExtension({
  id: 'task-state-change',
  priority: 10,
  predicate: options =>
    isTaskActivityType(options.activity, TASK_ACTIVITY_TYPES.stateChanged) &&
    options.change.fieldPath === '/state',
  title: change => getActionTitle(change.newValue),
  render: ({ activity }) => <TaskActivityContext activity={activity} />,
  values: change => ({
    oldValue: { state: change.oldValue },
    newValue: { state: change.newValue },
  }),
});
